import { render, staticRenderFns } from "./TemporaryLeaves.vue?vue&type=template&id=5e86f45e&"
import script from "./TemporaryLeaves.vue?vue&type=script&lang=js&"
export * from "./TemporaryLeaves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports